import axios from 'axios'
import { MessageBox, Notification } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_SERVER_BASE_API || "", // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      config.headers['authorization'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    //console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(

  (response) => {
 
    const res = response.data
    if (!res.result && typeof res.message === "string") {
      
      MessageBox({
        title: "Error",
        message: res.message || 'Error',
        type: 'error',
        duration: 3000,
        customClass: "el-message-box--error"
      })
    }

    return res

  },
  (error) => {
    Notification.closeAll()
    //console.log(error) // for debug
    if (error.response && error.response.status === 401) {
      // to re-login
      MessageBox.alert('You have been logged out because your authentication is no longer valid', 'Confirm logout', {
        confirmButtonText: 'OK',
        type: 'warning'
      }).then(async () => {
        await store.dispatch('user/resetToken')
        location.reload()
      })

    }else if (error.response && error.response.status === 403) {
      // to re-login
      MessageBox({
        message: "Error 403 - Forbidden",
        type: "error",
        duration: 3000,
      });

    }else{
      MessageBox({
        message: error.message,
        type: 'error',
        duration: 3000
      })

    }


    return Promise.reject(error)
  }
)

export default service
